import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgWarningTriangle = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="20"
        viewBox="0 0 22 20"
        width="22"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M11.0001 7.07141C11.4974 7.07141 11.9005 7.47455 11.9005 7.97185L11.8974 8.04663L11.5268 12.4943C11.5057 12.7479 11.2937 12.943 11.0392 12.943H10.961C10.7065 12.943 10.4945 12.7479 10.4734 12.4943L10.1028 8.04663C10.0615 7.55105 10.4297 7.11582 10.9253 7.07452C10.9502 7.07245 10.9751 7.07141 11.0001 7.07141Z"
            fill="#E42727"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M11 14.2866C11.4536 14.2866 11.8213 14.6543 11.8213 15.1079C11.8213 15.5615 11.4536 15.9292 11 15.9292C10.5464 15.9292 10.1787 15.5615 10.1787 15.1079C10.1787 14.6543 10.5464 14.2866 11 14.2866Z"
            fill="#E42727"
            fillRule="evenodd"
        />
        <path
            d="M11.002 0.667115C11.7852 0.66769 12.4424 1.15205 12.8733 1.84924L21.3247 15.5221L21.4207 15.6854C21.8786 16.506 22.0132 17.4063 21.5913 18.1661C21.1408 18.9774 20.2201 19.3329 19.2066 19.3329H2.79519C1.78283 19.3329 0.86105 18.9794 0.40969 18.1683C-0.0415604 17.3575 0.142731 16.3865 0.677024 15.5221L9.12844 1.84924L9.21194 1.72034C9.64297 1.09152 10.2674 0.666607 11.002 0.667115ZM11.0012 2.16711C10.9047 2.16704 10.7114 2.2178 10.4973 2.5011L10.4043 2.63806L1.9529 16.3109C1.57434 16.9234 1.63493 17.2857 1.71999 17.4388C1.80502 17.5916 2.07998 17.8329 2.79519 17.8329H19.2066C19.9201 17.8329 20.195 17.5917 20.2803 17.4381C20.3553 17.3029 20.4104 17.0078 20.1704 16.5277L20.0489 16.3109L11.5974 2.63806C11.3484 2.23517 11.1122 2.16731 11.0012 2.16711Z"
            fill="#E42727"
        />
    </svg>
);

export const WarningTriangle = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgWarningTriangle}
        fontSize={fontSize}
    />
);
